// Curated brand lists to feature by gender selection

export type FeaturedGender = "mens" | "womens" | "combined";

const MENS_BRANDS: string[] = [
  "Aime Leon Dore",
  "Saint Laurent",
  "Prada",
  "Ralph Lauren",
  "Levi's",
  "Nike",
  "Uniqlo",
  "Everlane",
];

const WOMENS_BRANDS: string[] = [
  "Ganni",
  "Prada",
  "Reformation",
  "Aritzia",
  "Levi's",
  "Zara",
  "H&M",
  "Madewell",
];

const COMBINED_BRANDS: string[] = [
  "Gucci",
  "Prada",
  "Ganni",
  "Ralph Lauren",
  "Aritzia",
  "Nike",
  "Zara",
  "Levi's",
];

export function getFeaturedBrandsByGender(gender: FeaturedGender | "unisex"): string[] {
  if (gender === "mens") return MENS_BRANDS;
  if (gender === "womens") return WOMENS_BRANDS;
  // Treat 'unisex' as combined
  return COMBINED_BRANDS;
}
